<div class="categories">
  <app-page-header pageTitle="Impact Partners" [showSearch]="false">
    <button class="button" (click)="togglePartnerModal(true)" addButton>
      <img src="assets/images/add.svg" alt="+" />
      Add <span>Partners</span>
    </button>
  </app-page-header>

  <div class="table-block">
    <div class="table-block__wrap">
      <table class="isLoader">
        <tr>
          <th>Media Partner ID</th>
          <th>Name</th>
          <th>Associated Phone No.</th>
          <th>Action</th>
        </tr>
        <ng-container
          *ngIf="
            isLoading && (partnersFilter | async)?.pageNumber === 1;
            else partnersTable
          "
        >
          <ng-container *ngFor="let i of [].constructor(10)">
            <tr>
              <td>
                <app-skeleton
                  height="15px"
                  width="100px"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="100%"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="100%"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <div class="table-block__action flex align-center">
                  <app-skeleton
                    height="15px"
                    width="15px"
                    margin="0"
                  ></app-skeleton>
                  <app-skeleton
                    height="15px"
                    width="15px"
                    margin="0 0 0 10px"
                  ></app-skeleton>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </table>
    </div>
  </div>
</div>

<ng-template #partnersTable>
  <ng-container *ngIf="partners.length > 0; else noDataFound">
    <ng-container *ngFor="let partner of partners; let i = index">
      <tr
        inViewport
        [lastElement]="partners.length === i + 1"
        (elementIsVisible)="loadMoreIfLastIndex()"
      >
        <td>{{ partner.mediaPartnerId }}</td>
        <td>
          <p>{{ partner.name | titlecase }}</p>
        </td>
        <td>
          <p>{{ partner.phone | titlecase }}</p>
        </td>
        <td>
          <div class="table-block__action flex align-center">
            <img
              src="assets/images/edit.svg"
              alt="Edit"
              (click)="handleEditPartner(partner)"
            />
            <img
              src="assets/images/transh.svg"
              alt="transh"
              (click)="onDeletePartner(partner.id ?? '')"
            />
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="isLoading && (partnersFilter | async)?.pageNumber !== 1">
      <td>
        <app-skeleton height="15px" width="100px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100%" margin="0"></app-skeleton>
      </td>
      <td>
        <div class="table-block__action flex align-center">
          <app-skeleton height="15px" width="15px" margin="0"></app-skeleton>
          <app-skeleton
            height="15px"
            width="15px"
            margin="0 0 0 10px"
          ></app-skeleton>
        </div>
      </td>
    </tr>
  </ng-container>
</ng-template>

<ng-container *ngIf="deletePartnerId">
  <app-confirmation-modal
    primaryButtonText="Cancel"
    secondaryButtonText="Yes"
    message="Are you sure you  want to delete this media partner ?"
    caption="Delete Confirmation"
    (onPrimaryButtonClick)="cancelDelete()"
    (onSecondaryButtonClick)="deletePartner()"
    [secondaryButtonLoading]="deleteLoading"
  ></app-confirmation-modal>
</ng-container>

<ng-template #noDataFound>
  <tr>
    <td colspan="3">
      <div class="table-block__nodata">No data found</div>
    </td>
  </tr>
</ng-template>

<app-modal
  *ngIf="showEditPartnerModal"
  (closeModal)="togglePartnerModal(false)"
  [modalTitle]="editPartner ? 'Edit Media Partner' : 'Add Media Partner'"
>
  <app-add-edit-partners
    (onClose)="togglePartnerModal(false)"
    [editPartner]="editPartner"
    (onUpdate)="handleUpdate()"
  ></app-add-edit-partners>
</app-modal>
